(() => {
  const buildNestedMobileMenus = () => {
    const drawer = document.getElementById('MenuDrawer');
    if (!drawer) return;
    const bodies = drawer.querySelectorAll('.Accordion__Body');
    ['women', 'men', 'children', 'health', 'handicrafts'].forEach((category, index) => {
      const body = bodies[index];
      const megaMenu = document.querySelector(`#Header .MegaMenu--${category}`);
      if (!body || !megaMenu) return;
      const shopSource = megaMenu.querySelector('.MegaMenu__Title');
      const seen = new Set();
      const links = [...megaMenu.querySelectorAll('a[href]')].filter(source => {
        const path = new URL(source.href, location.origin).pathname;
        const keep = source.textContent.trim() && !source.classList.contains('MegaMenu__Title') && !seen.has(path);
        if (keep) seen.add(path);
        return keep;
      });
      const fragment = document.createDocumentFragment();
      const nested = document.createElement('div');
      nested.className = 'NGNestedMenu';
      const header = document.createElement('div');
      header.className = 'NGNestedMenu__Header';
      const title = document.createElement('a');
      title.className = 'MenuDrawer__Title Nav__Link';
      title.href = shopSource ? shopSource.href : links[0].href;
      title.textContent = shopSource ? shopSource.textContent.trim() : `Shop ${category}`;
      const list = document.createElement('ul');
      list.className = 'Nav Nav--vertical NGNestedMenu__Children';
      list.id = `ng-mobile-${category}-shop-links`;
      list.hidden = true;
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'NGNestedMenu__Toggle';
      toggle.setAttribute('aria-controls', list.id);
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', `Show ${title.textContent} subcategories`);
      toggle.textContent = '+';
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        toggle.textContent = expanded ? '+' : '−';
        list.hidden = expanded;
      });
      links.slice(0, 3).forEach(source => {
        const item = document.createElement('li');
        item.className = 'Nav__Item';
        const link = document.createElement('a');
        link.className = 'Nav__Link';
        link.href = source.href;
        link.textContent = source.textContent.trim();
        item.append(link);
        list.append(item);
      });
      header.append(title, toggle);
      nested.append(header, list);
      fragment.append(nested);
      links.slice(3).forEach(source => {
        const item = document.createElement('div');
        item.className = 'Nav__Item';
        const link = document.createElement('a');
        link.className = 'Nav__Link';
        link.href = source.href;
        link.textContent = source.textContent.trim();
        item.append(link);
        fragment.append(item);
      });
      body.replaceChildren(fragment);
    });
  };
  const queueBuild = () => setTimeout(buildNestedMobileMenus, 20);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queueBuild, { once: true });
  else queueBuild();
  document.addEventListener('shopify:section:load', queueBuild);
})();


(() => {
  const normalizePromotionalLinks = () => {
    document.querySelectorAll('#Header .MegaMenu, #MenuDrawer .Accordion__Body').forEach(scope => {
      const arrivals = [...scope.querySelectorAll('a[href]')].filter(link =>
        link.textContent.trim().toLowerCase() === 'new arrivals'
      );
      arrivals.forEach((link, index) => {
        if (index === 0) link.href = '/collections/new-arrivals';
        else (link.closest('li') || link).remove();
      });
      scope.querySelectorAll('a[href]').forEach(link => {
        if (link.textContent.trim().toLowerCase() === 'sale') link.href = '/collections/sale';
      });
    });
  };
  const queueNormalization = () => setTimeout(normalizePromotionalLinks, 0);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueNormalization, { once: true });
  } else {
    queueNormalization();
  }
  document.addEventListener('shopify:section:load', queueNormalization);
})();

(() => {
  const restorePromotionalMenuLinks = () => {
    document.querySelectorAll('#Header .MegaMenu').forEach(megaMenu => {
      const list = megaMenu.querySelector('.MegaMenu__Item--link .Nav--vertical');
      if (!list) return;

      const existingPaths = new Set(
        [...list.querySelectorAll('a[href]')].map(link => new URL(link.href, location.origin).pathname)
      );

      [
        { title: 'New Arrivals', path: '/collections/new-arrivals' },
        { title: 'Sale', path: '/collections/sale' }
      ].forEach(({ title, path }) => {
        if (existingPaths.has(path)) return;

        const item = document.createElement('li');
        item.className = 'Nav__Item';
        const link = document.createElement('a');
        link.className = 'Nav__Link';
        link.href = path;
        link.textContent = title;
        item.append(link);
        list.append(item);
        existingPaths.add(path);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restorePromotionalMenuLinks, { once: true });
  } else {
    restorePromotionalMenuLinks();
  }
  document.addEventListener('shopify:section:load', restorePromotionalMenuLinks);
})();





(()=>{const hideUnusedHealthColumn=()=>{document.querySelectorAll('#Header .MegaMenu--health > .MegaMenu__Item--link').forEach(item=>{if(item.querySelector(':scope > .MegaMenu__Title')?.getAttribute('href')==='/collections/personal-care')item.style.setProperty('display','none','important');});};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',hideUnusedHealthColumn,{once:true});else hideUnusedHealthColumn();})();
(()=>{const f=()=>{document.querySelectorAll('.ng-request:not([data-ng-layout])').forEach(r=>{r.dataset.ngLayout=1;[['variant','option'],['quantity','quantity']].forEach(([n,c])=>{const e=r.querySelector('[data-request-'+n+']'),l=r.querySelector('label[for="'+e?.id+'"]'),w=document.createElement('div');w.className='ng-request__field ng-request__field--'+c;if(!e||!l)return;l.before(w);w.append(l,e)});const b=r.querySelector('[data-interest-add]'),a=document.createElement('div');a.className='ng-request__action';if(!b)return;b.before(a);a.append(b)});document.querySelectorAll('.ProductGallery:not([data-ng-gallery])').forEach(g=>{g.dataset.ngGallery=1;g.dataset.ngLabel=1;const t=document.querySelector('.PageHeader__Title')?.textContent.trim(),n=g.querySelectorAll('.ProductGallery__Inner>feature-img').length;if(t&&n){const x=document.createElement('div');x.className='ProductGallery__count';x.style.textTransform='none';x.innerHTML='<span style="display:inline-block;font-size:1.2em;line-height:1;font-variant-numeric:lining-nums">'+n+'</span> Picture'+(n===1?'':'s')+' available for this Product';g.before(x);document.querySelector('.Breadcrumb__Item:last-child a')?.replaceChildren(t)}})};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',f,{once:true}):f()})();


(()=>setTimeout(()=>document.querySelectorAll('.ProductGallery').forEach(g=>{if(g.dataset.ngLabel)return;const t=document.querySelector('.PageHeader__Title')?.textContent.trim(),n=new Set([...g.querySelectorAll('[data-media-id]')].map(e=>e.dataset.mediaId)).size;if(t&&n){g.dataset.ngLabel=1;const x=document.createElement('div');x.className='ProductGallery__count';x.textContent='Now showing '+n+' product pictures of '+t;g.before(x);document.querySelector('.Breadcrumb__Item:last-child a')?.replaceChildren(t)}}),800))();

;(()=>{
const bind=()=>{const hero=document.querySelector('[id$="__banner_wC3iWM"] [data-ng-static-scene]');if(!hero||hero.dataset.windBound)return;hero.dataset.windBound='true';
const reduced=matchMedia('(prefers-reduced-motion: reduce)'),desktop=matchMedia('(min-width: 1008px)');let visible=true;
const sync=()=>{hero.classList.toggle('ng-mandala-allow-motion',desktop.matches);hero.classList.toggle('ng-mandala-paused',!visible||document.hidden||(reduced.matches&&!desktop.matches));};
new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:0}).observe(hero);document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',sync);desktop.addEventListener('change',sync);sync();};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind,{once:true});else bind();document.addEventListener('shopify:section:load',bind);
})();


(() => {
  const isImage = target => target instanceof Element && Boolean(target.closest('img'));
  const isProductGalleryOpener = target => target instanceof Element && Boolean(target.closest('.ProductGallery .MediaModalOpener--image'));

  document.addEventListener('contextmenu', event => {
    if (isImage(event.target)) event.preventDefault();
  }, true);

  document.addEventListener('dragstart', event => {
    if (isImage(event.target)) event.preventDefault();
  }, true);

  document.addEventListener('click', event => {
    if (!isProductGalleryOpener(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('keydown', event => {
    if (!['Enter', ' '].includes(event.key) || !isProductGalleryOpener(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  const disableImageDragging = root => {
    root.querySelectorAll?.('img').forEach(image => image.draggable = false);
  };

  disableImageDragging(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (!(node instanceof Element)) return;
      if (node.matches('img')) node.draggable = false;
      disableImageDragging(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();



;(()=>{const warm=()=>{const ready=()=>document.documentElement.classList.add('ng-menu-background-ready');if('requestIdleCallback'in window)requestIdleCallback(ready,{timeout:1500});else setTimeout(ready,0);};if(document.readyState==='complete')warm();else window.addEventListener('load',warm,{once:true});})();

